const CONTACT_DETAILS = {
  telephone: "+44 (0)141 582 2000",
  contactUsUrl: "http://www.accaglobal.com/gb/en/footertoolbar/contact-us/connect.html",
};

export default CONTACT_DETAILS;
